import { render, staticRenderFns } from "./RelatorioParecerReferencial.vue?vue&type=template&id=04e91271"
import script from "./RelatorioParecerReferencial.vue?vue&type=script&lang=ts&setup=true"
export * from "./RelatorioParecerReferencial.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports